import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

/**
 * Rotating category card for the "Choose Your Sport" grid.
 * Fades between a list of images every `intervalMs`. Preserves label + overlay.
 */
export default function CategoryCarouselCard({
  to,
  label,
  testId,
  images,
  size = "sm",   // "lg" for the featured rugby card, "sm" for hockey/netball, "equal" for uniform grid
  intervalMs = 3800,
  eyebrow = "In Stock",
}) {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (!images || images.length <= 1) return;
    const id = setInterval(() => setIdx((i) => (i + 1) % images.length), intervalMs);
    return () => clearInterval(id);
  }, [images, intervalMs]);

  const isLarge = size === "lg";
  const wrapCls = size === "equal"
    ? "relative block w-full aspect-[3/4] overflow-hidden border border-[#262626] group cursor-pointer"
    : isLarge
    ? "md:col-span-6 relative aspect-[4/3] overflow-hidden border border-[#262626] group cursor-pointer"
    : "md:col-span-3 relative aspect-[3/4] md:aspect-auto overflow-hidden border border-[#262626] group cursor-pointer";
  const titleCls = isLarge
    ? "text-white text-2xl sm:text-3xl font-bold uppercase tracking-tight font-heading"
    : "text-white text-xl font-bold uppercase tracking-tight font-heading";

  return (
    <Link to={to} data-testid={testId} className={wrapCls}>
      {images.map((src, i) => (
        <img
          key={src}
          src={src}
          alt={`${label} ${i + 1}`}
          loading={i === 0 ? "eager" : "lazy"}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out group-hover:scale-105 transform-gpu ${
            i === idx ? "opacity-100" : "opacity-0"
          }`}
        />
      ))}
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
      <div className={`absolute bottom-0 left-0 ${isLarge ? "p-6" : "p-4"}`}>
        <p className="text-[#F7931E] text-xs font-bold tracking-[0.2em] uppercase mb-1">{eyebrow}</p>
        <h3 className={titleCls}>{label}</h3>
      </div>
    </Link>
  );
}
